import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

export const impersonationService = {
  // Get list of users that can be impersonated
  getImpersonatableUsers: async () => {
    return api.getCall("/api/login/impersonatable-users");
  },

  // Impersonate a user
  impersonateUser: async (userId) => {
    return api.postCall("/api/login/admin-login-as", { userId });
  },
};
